import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { Button as l } from "../../forms/button/index.js";
import '../../../assets/clients.css';const m = "_clients_1gir3_1", n = {
  clients: m,
  "clients--info": "_clients--info_1gir3_5",
  "clients--info--subtitle": "_clients--info--subtitle_1gir3_9",
  "clients--info--title": "_clients--info--title_1gir3_12",
  "clients--info--content": "_clients--info--content_1gir3_15",
  "clients--info--actions": "_clients--info--actions_1gir3_18",
  "clients--options": "_clients--options_1gir3_22",
  "clients--option": "_clients--option_1gir3_22",
  "clients--option--info": "_clients--option--info_1gir3_37",
  "clients--option--info--title": "_clients--option--info--title_1gir3_40",
  "clients--option--info--content": "_clients--option--info--content_1gir3_44",
  "clients--option--action": "_clients--option--action_1gir3_48"
};
function _({
  options: t = [
    {
      id: "quoter",
      buttonContent: "Empezar ahora",
      content: /* @__PURE__ */ e("p", { children: "Conviértete en un tasador asignado en Bohiio y aprovecha la flexibilidad para manejar tu tiempo mientras realizas tasaciones y generas ingresos constantes cada semana. Regístrate como colaborador y amplía tus oportunidades de ingresos al trabajar con nosotros." }),
      title: "¿Eres tasador o valuador?"
    },
    {
      id: "layer",
      buttonContent: "Empezar ahora",
      content: /* @__PURE__ */ e("p", { children: "Conviértete en nuestro aliado legal en Bohiio y realiza los procesos legales necesarios para regularizar las propiedades de nuestros clientes. Regístrate como colaborador y amplía tus oportunidades de ingresos al trabajar con nosotros." }),
      title: "¿Abogado?"
    },
    {
      id: "land",
      buttonContent: "Empezar ahora",
      content: /* @__PURE__ */ e("p", { children: "Conviértete en un agrimensor de Bohiio y realiza procesos técnicos de Mensuras Catastrales para nuestros clientes. Regístrate como colaborador y amplía tus oportunidades de ingresos al trabajar con nosotros." }),
      title: "¿Agrimensor?"
    }
  ],
  onClickButton: o = () => {
  },
  buttonContent: a = "Empezar ahora",
  content: s = /* @__PURE__ */ e("p", { children: "¡Aprovecha tu experiencia para generar ganancias adicionales todas las semanas con Bohiio!¡Amplía tus oportunidades como agente inmobiliario! Regístrate para ser parte de nuestro programa de referidos y comienza a generar ingresos adicionales de manera constante. Al referir clientes que necesiten realizar una tasación o regularizar un inmueble, obtendrás una comisión del 10% sobre el total de la factura cobrada al cliente que refieras." }),
  subtitle: c = "Genera ingresos semanalmente",
  title: d = "¿Eres agente inmobiliario?"
}) {
  return /* @__PURE__ */ i("section", { className: `${n.clients}`, children: [
    /* @__PURE__ */ i("article", { className: `${n["clients--info"]}`, children: [
      /* @__PURE__ */ e("h5", { className: `${n["clients--info--subtitle"]} b-mb-4 md:b-mb-2`, children: c }),
      /* @__PURE__ */ e("h2", { className: `${n["clients--info--title"]} b-mb-6 md:b-mb-2`, children: d }),
      /* @__PURE__ */ e("div", { className: `${n["clients--info--content"]} b-mb-6 md:b-mb-0`, children: s }),
      /* @__PURE__ */ e("div", { className: `${n["clients--info--actions"]}`, children: /* @__PURE__ */ e(l, { className: "md:b-max-w-52 b-w-full", onClick: o, children: a }) })
    ] }),
    /* @__PURE__ */ e("article", { className: `${n["clients--options"]}`, children: t.map((r) => /* @__PURE__ */ e(p, { ...r }, r.id)) })
  ] });
}
function p({
  buttonContent: t = "",
  content: o = "",
  onClickButton: a = () => {
  },
  title: s = ""
}) {
  return /* @__PURE__ */ i("article", { className: `${n["clients--option"]}`, children: [
    /* @__PURE__ */ i("div", { className: `${n["clients--option--info"]}`, children: [
      /* @__PURE__ */ e("h5", { className: `${n["clients--option--info--title"]} `, children: s }),
      /* @__PURE__ */ e("div", { className: `${n["clients--option--info--content"]} `, children: o })
    ] }),
    /* @__PURE__ */ e("div", { className: `${n["clients--option--action"]}`, children: /* @__PURE__ */ e(
      l,
      {
        className: "md:b-max-w-52",
        styleType: "neutral",
        onClick: a,
        children: t
      }
    ) })
  ] });
}
export {
  _ as default
};
